import { DirectoryRole } from 'Services/Api/Directory/Types';

export const SUPERADMIN_ROLE_ID = 1;

export const ROLE_DISPLAY_LABEL: Record<string, string> = {
	superadmin: 'Superadmin',
	admin: 'Leadership & IT Team',
	manager: 'Manager',
	user: 'Staff'
};

export const ROLE_DESCRIPTION: Record<string, string> = {
	admin: 'Those overseeing system and strategy',
	manager: 'Department and property managers',
	user: 'All users other than Managers and Leadership team'
};

const normalize = (value: string) => value.trim().toLowerCase();

export const roleDisplayLabel = (name: string) =>
	ROLE_DISPLAY_LABEL[normalize(name)] ?? name;

export const roleDescription = (name: string) =>
	ROLE_DESCRIPTION[normalize(name)] ?? '';

export const isSuperAdminRole = (role: DirectoryRole) =>
	role.id === SUPERADMIN_ROLE_ID || normalize(role.name) === 'superadmin';

export const visibleRoles = <T extends DirectoryRole>(roles: T[]) =>
	roles.filter((role) => !isSuperAdminRole(role));

export const roleMatchesSearch = (name: string, search: string) => {
	const term = normalize(search);
	if (!term) return true;
	return [name, roleDisplayLabel(name)].some((value) =>
		normalize(value).includes(term)
	);
};

export const filterRolesForUser = <T extends DirectoryRole>(
	roles: T[],
	search = ''
) =>
	visibleRoles(roles).filter((role) =>
		roleMatchesSearch(role.name, search)
	);